import http from '@/plugins/api'
import { startLoading } from '@/plugins/loading'
import * as types from './types'

export default {
  setFilterBy({ commit }, filterBy) {
    commit(types.SET_FILTER_BY, filterBy)
  },
  setTypeBy({ commit }, typeBy) {
    commit(types.SET_TYPE_BY, typeBy)
  },
  setFilter({ commit }, filter) {
    commit(types.SET_FILTER, filter)
  },
  setSearchTerm({ commit }, text) {
    commit(types.SET_SEARCH_TERM, text)
  },
  setPageSize({ commit }, pageSize) {
    commit(types.SET_PAGE_SIZE, pageSize)
  },
  setRetrospectiveDay({ commit }, days) {
    commit(types.SET_DAYS, days)
  },
  resetModuleState({ commit, dispatch }) {
    commit(types.RESET_MODULE_STATE)
  },
  setStartDate({ commit }, date) {
    commit(types.SET_START_DATE, date)
  },
  setEndDate({ commit }, date) {
    commit(types.SET_END_DATE, date)
  },
  async getReviewRequestReport({ commit, dispatch }, id) {
    const r = await startLoading(dispatch, 'getReviewRequestReport', () =>
      http.get('report/CreateReviewPdf', {
        params: { id }
      })
    )
    return r.data
  },
  async getReviewRequestDashboard({ commit, dispatch }, searchOptions) {
    const r = await startLoading(dispatch, 'getDashboard', () =>
      http.get(`servicerequest/ReviewRequestDashboardGet`, {
        params: searchOptions
      })
    )
    commit(types.SET_DATA, r.data)
    return r.data
  },
  async getWorkOrderBreakdown({ commit, dispatch }, options) {
    const r = await startLoading(dispatch, 'getWorkOrderBreakdown', () =>
      http.get(`dashboard/GetServiceRequestBreakdownSummary2`, {
        params: options
      })
    )
    return r.data
  },
  async getDashboardData({ commit, dispatch }, searchOptions) {
    const r = await startLoading(dispatch, 'getDashboard', () =>
      http.get(`dashboard/DashboardSummaryBreakdown`, {
        params: searchOptions
      })
    )
    commit(types.DASHBOARD_DATA, r.data)
    return r.data
  },
  async getDashboardSummaryBreakdown({ commit, dispatch }, options) {
    const r = await startLoading(dispatch, 'getDashboardSummaryBreakdown', () =>
      http.get(`dashboard/DashboardSummaryBreakdown`, {
        params: options
      })
    )
    commit(types.SET_BREAKDOWN_SUMMARY, r.data)
    return r.data
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/dashboard/actions.js